<template>
  <div class="buildings">
    <MobileTable
      v-model:selection="store.state.personnel.selectedPersonnelList"
      :label="$route.name"
      :columns="personnel.columns"
      :data="store.state.personnel.personnelList"
    />
    <DesktopTable
      v-model:selection="store.state.personnel.selectedPersonnelList"
      :label="$route.name"
      :columns="personnel.columns"
      :data="store.state.personnel.personnelList"
    />
    <Actions :items="personnel.actions" />
  </div>
</template>

<script>
import { useRouter, useRoute } from "vue-router";
import Actions from "../../components/shared/Actions.vue";
import MobileTable from "../../widgets/tables/MobileTable";
import DesktopTable from "../../widgets/tables/DesktopTable";
import { onBeforeMount, reactive } from "vue";
import store from "../../store";
import { openMode, actions } from "../../constants";

export default {
  components: { MobileTable, DesktopTable, Actions },

  setup() {
    const router = useRouter();
    const route = useRoute();
    const onCreate = () => {
      store.commit("setOpenMode", openMode.CREATE);
      router.push("/personal/nuevo");
    };
    const onModify = () => {
      if (store.state.personnel.selectedPersonnelList.length !== 1) {
        alert("Debe seleccionar un registro!");
      } else {
        store.commit("setOpenMode", openMode.MODIFY);
        router.push("/personal/modificar");
      }
    };
    const onChangeStatus = async (status) => {
      if (!store.state.personnel.selectedPersonnelList.length) {
        alert("Debe seleccionar un registro!");
      } else {
        store.commit("setLoading", true);

        const users = store.state.personnel.selectedPersonnelList.map(
          (item) => item.userId
        );
        if (users.includes(store.state.auth.user.id)) {
          alert("No se puede modificar el usuario que ha iniciado sesión!");
          return;
        }

        const response = await store.dispatch(actions.personnelActions.status, {
          users,
          status,
        });

        if (response.ok) {
          store.commit("setSelectedPersonnelList", []);
          await store.dispatch(
            actions.personnelActions.findAll,
            store.state.auth.user.company
          );
          store.commit("setLoading", false);
        } else {
          store.state.toast.add({
            severity: "error",
            summary: "",
            detail: response.message,
            life: 5000,
          });
          store.commit("setLoading", false);
        }
      }
    };

    const personnel = reactive({
      columns: [
        {
          field: "name",
          header: "Nombre",
          sort: true,
          center: true,
        },
        {
          field: "identity",
          header: "Rut / CI",
        },
        {
          field: "email",
          header: "Email",
        },
        {
          field: "phone",
          header: "Teléfono",
        },
        {
          field: "personnelType",
          header: "Cargo",
          sort: true,
          center: true,
        },
        {
          field: "active",
          header: "Habilitado",
          center: true,
          sort: true,
        },
      ],
      actions: [
        {
          name: "Nuevo",
          action: onCreate,
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/personal/nuevo"),
        },
        // {
        //   name: "Modificar",
        //   action: onModify,
        //   hidden: router
        //     .getRoutes()
        //     .find((route) => route.path === "/personal/modificar"),
        // },
        {
          name: "Habilitar",
          action: () => onChangeStatus(true),
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/personal/modificar"),
        },
        {
          name: "Deshabilitar",
          action: () => onChangeStatus(false),
          hidden: router
            .getRoutes()
            .find((route) => route.path === "/personal/modificar"),
        },
      ],
    });

    onBeforeMount(async () => {
      store.commit("setLoading", true);
      store.commit("setSelectedPersonnelList", []);
      store.commit("setBreadcrumbs", [
        { label: "Inicio", to: "/home" },
        { label: "Personal", to: "/personal" },
        { label: route.name, to: route.path },
      ]);
      await store.dispatch(
        actions.personnelActions.findAll,
        store.state.general.selectedBuilding
      );
      store.commit("setLoading", false);
    });

    return { store, personnel };
  },
};
</script>

<style scoped></style>
